<template>
  <div class="teleconsulta-options scroll-container p-3">
    <form>
      <h6>Informações do evento</h6>
      <b-row>
        <b-col cols="12" md="3">
          <b-form-group label="Título do evento">
            <b-form-input
              id="title-input"
              v-model="summary"
              @focus="handleFocus($event)"
              @change="updateJson"
              placeholder="Título do evento"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="Identificador de calendário">
            <b-form-select
              id="id-calendar-select"
              v-model="calendarId"
              @change="updateJson"
              :options="calendars"
              required
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4">
          <b-form-group label="Descrição">
            <b-form-textarea
              type="text"
              v-model="description"
              @change="updateJson"
              @focus="handleFocus($event)"
              required
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
      <h6>Data, horários e duração</h6>
      <b-row>
        <b-col cols="12" md="3">
          <b-form-group label="Data e horário de início">
            <b-form-input
              id="start-date-input"
              type="text"
              @focus="handleFocus($event)"
              v-model="date_start"
              @change="updateJson"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="3">
          <b-form-group label="Data e horário de fim">
            <b-form-input
              id="end-date-input"
              type="text"
              v-model="date_end"
              @focus="handleFocus($event)"
              @change="updateJson"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="3">
          <b-form-group label="Duração">
            <b-form-input
              v-model="duration"
              list="duration-options"
              @change="updateJson"
              required
            ></b-form-input>
            <datalist id="duration-options">
              <option
                v-for="option in durationOptions"
                :key="option.value"
                :value="option.value"
              >
                {{ option.text }}
              </option>
            </datalist>
          </b-form-group>
        </b-col>
      </b-row>

      <h6>Participantes</h6>
      <b-row class="mb-3">
        <b-col cols="12" md="2">
          <b-form-group label="Máximo de participantes">
            <b-form-input
              type="number"
              v-model="max_participants"
              @focus="handleFocus($event)"
              @change="updateJson"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <div
        v-for="(attendee, index) in attendees"
        :key="'att-' + index"
        class="participant-card mb-4"
      >
        <div class="participant-header">
          <b-form-group class="mb-0" style="width: 160px">
            <b-form-select
              v-model="attendee.organizer"
              :options="[
                { value: true, text: 'Organizador' },
                { value: false, text: 'Convidado' }
              ]"
              @change="updateJson"
              size="sm"
              class="font-weight-bold shadow-none"
              style="border-color: #472282; color: #472282"
            ></b-form-select>
          </b-form-group>

          <b-button
            v-if="index > 1"
            size="sm"
            variant="link"
            class="text-danger p-0"
            title="Remover participante"
            @click="removeAttendee(index)"
          >
            <i class="fas fa-trash"></i> Remover
          </b-button>
        </div>

        <div class="participant-body">
          <BindKeyValueEditor
            :value="attendeeBindItems(attendee)"
            :selectOptions="availableVariables"
            :fixedItems="[
              { key: 'name', value: attendee.name, fixed: true },
              { key: 'email', value: attendee.email, fixed: true },
              { key: 'phone', value: attendee.phone, fixed: true }
            ]"
            :fixedLabelMap="{
              name: 'Nome',
              email: 'E-mail',
              phone: 'Telefone'
            }"
            @input="updateAttendeeBindItems(index, $event)"
          />
        </div>
      </div>
      <div class="d-flex justify-content-start mb-4">
        <b-button size="sm" class="btn-add-participant" @click="addAttendee()">
          <i class="fas fa-plus"></i> Adicionar participante
        </b-button>
      </div>
      <h6>Permissões de convidados</h6>
      <b-row>
        <b-col cols="12" md="12">
          <b-form-group>
            <b-form-checkbox
              v-model="guestsCanModify"
              inline
              @change="updateJson"
              >Modificar o evento</b-form-checkbox
            >
            <b-form-checkbox
              v-model="guestsCanInviteOthers"
              inline
              @change="updateJson"
              >Convidar participantes</b-form-checkbox
            >
            <b-form-checkbox
              v-model="guestsCanSeeOtherGuests"
              inline
              @change="updateJson"
              >Ver outros participantes</b-form-checkbox
            >
          </b-form-group>
        </b-col>
      </b-row>

      <h6>Lembretes</h6>
      <b-row>
        <b-col cols="12" md="12">
          <b-form-group>
            <b-form-checkbox
              v-model="sendReminder"
              @change="handleSendReminderChange"
              inline
              >Enviar lembrete</b-form-checkbox
            >
            <b-form-checkbox
              v-model="reminders.useDefault"
              :disabled="!sendReminder"
              @change="updateJson"
              inline
              >Utilizar lembrete padrão</b-form-checkbox
            >
          </b-form-group>
        </b-col>
      </b-row>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import ApiService from "../../core/services/api.service";
import API_LINKS from "../pages/painel/automacao/api.links";
import Swal from "sweetalert2";
import { required } from "vuelidate/lib/validators";
import BindKeyValueEditor from "@/view/components/BindKeyValueEditor.vue";
export default {
  name: "TeleconsultaOptions",
  components: {
    BindKeyValueEditor
  },
  data() {
    return {
      formData: {
        url: process.env.VUE_APP_COMUNICANTE_API + "/google/calendar/event",
        method: "POST",
        headers: '{"Content-Type": "application/json"}',
        batchSize: 1,
        format: "{}",
        formatConfig: "",
        sendAs: "data",
        contentType: "application/json"
      },
      formatIsValidJson: true,
      headersIsValidJson: true,
      parsedJson: null,
      durationOptions: [
        { value: "00:15:00", text: "15 minutos" },
        { value: "00:30:00", text: "30 minutos" },
        { value: "00:45:00", text: "45 minutos" },
        { value: "01:00:00", text: "1 hora" },
        { value: "01:30:00", text: "1 hora e meia" },
        { value: "02:00:00", text: "2 horas" }
      ],
      max_participants: 2,
      summary: "",
      calendarId: "",
      description: "",
      date_start: "",
      date_end: "",
      duration: "01:00:00",
      calendars: [],
      guestsCanModify: false,
      guestsCanInviteOthers: false,
      guestsCanSeeOtherGuests: false,
      attendees: [
        {
          name: "",
          email: "",
          phone: "",
          organizer: true
        },
        {
          name: "",
          email: "",
          phone: "",
          organizer: false
        }
      ],
      reminders: {
        useDefault: false,
        overrides: []
      },
      sendReminder: false
    };
  },
  methods: {
    updateHeaders() {
      try {
        const headers = JSON.parse(this.formData.headers);
        headers["Content-Type"] = this.formData.contentType;
        this.formData.headers = JSON.stringify(headers);
        this.headersIsValidJson = true;
        this.formatJsonFormHeaders();
      } catch (e) {
        this.headersIsValidJson = false;
      }
      this.json["Teleconsulta"] = JSON.stringify(
        this.construirAxiosRequestConfig()
      );
    },
    updateJson() {
      this.formData.format = JSON.stringify({
        meeting: {
          access: this.access,
          provider: this.provider,
          moderator_code: this.moderatorCode,
          password: this.password,
          max_participants: this.max_participants ?? this.attendees.length
        },
        sli_token: this.sliToken,
        summary: this.summary,
        calendar_id: this.calendarId,
        description: this.description,
        start_date_time: this.date_start,
        end_date_time: this.date_end,
        duration: this.duration,
        attendees: this.attendees,
        reminders: this.reminders,
        guestsCanModify: this.guestsCanModify,
        guestsCanInviteOthers: this.guestsCanInviteOthers,
        guestsCanSeeOtherGuests: this.guestsCanSeeOtherGuests
      });

      this.json["Teleconsulta"] = JSON.stringify(
        this.construirAxiosRequestConfig()
      );
    },
    formatJsonFormFormat() {
      try {
        this.parsedJson = JSON.parse(this.formData.format);
        // this.formData.format = JSON.stringify(this.parsedJson, null, 2);
        this.formatIsValidJson = true;
      } catch (e) {
        this.formatIsValidJson = false;
      }
      this.updateJson();
    },
    formatJsonFormHeaders() {
      try {
        this.parsedJson = JSON.parse(this.formData.headers);
        // this.formData.headers = JSON.stringify(this.parsedJson, null, 2);
        this.headersIsValidJson = true;
      } catch (e) {
        this.headersIsValidJson = false;
      }
      this.updateJson();
    },
    construirAxiosRequestConfig() {
      return {
        requestConfig: {
          headers: JSON.parse(this.formData.headers),
          method: this.formData.method,
          url: this.formData.url
        },
        sendConfig: {
          sendAs: this.formData.sendAs,
          batchSize: this.formData.batchSize,
          format: this.formData.format ? this.formData.format : "{}",
          formatConfig: this.formData.formatConfig
            ? this.formData.formatConfig
            : "{}"
        }
      };
    },
    handleFocus(event) {
      this.$emit("focused", event.target.id);
    },
    loadCalendars(sli_token) {
      this.calendars = [];
      ApiService.get(
        API_LINKS.calendarios + "?sli_token=" + sli_token,
        "",
        false,
        {
          baseURL: process.env.VUE_APP_COMUNICANTE_API
        }
      )
        .then((response) => {
          this.calendars = response.data.data.map((v) => {
            return {
              text: v.summary,
              value: v.id
            };
          });
        })
        .catch(() => {
          Swal.fire({
            title: "Aviso!",
            text: "Esse sistema não possui calendários configurados.",
            icon: "warning",
            confirmButtonText: "Ok"
          });
        });
    },
    handleSendReminderChange() {
      if (!this.sendReminder) {
        this.reminders.useDefault = false;
        this.reminders.overrides = [];
      } else {
        this.reminders.overrides = [
          { method: "popup", minutes: 10 },
          { method: "email", minutes: 60 }
        ];
      }
      this.updateJson();
    },
    removeAttendee(index = null) {
      if (this.attendees.length <= 2) return;

      if (index === null || index === undefined) {
        this.attendees.pop();
      } else {
        this.attendees.splice(index, 1);
      }

      if (this.max_participants < this.attendees.length) {
        this.max_participants = this.attendees.length;
      }
      this.updateJson();
    },
    addAttendee() {
      this.attendees.push({
        name: "",
        email: "",
        phone: "",
        organizer: false
      });
      if (this.max_participants < this.attendees.length) {
        this.max_participants = this.attendees.length;
      }
      this.updateJson();
    },
    attendeeBindItems(attendee) {
      const fixedKeys = ["name", "email", "phone"];
      const fixedItems = fixedKeys.map((key) => ({
        key,
        value: attendee[key] || "",
        fixed: true
      }));

      const dynamicItems = Object.keys(attendee)
        .filter((key) => ![...fixedKeys, "organizer"].includes(key))
        .map((key) => ({
          key,
          value: attendee[key] || "",
          fixed: false
        }));

      return [...fixedItems, ...dynamicItems];
    },
    updateAttendeeBindItems(index, items) {
      const attendeeAtual = this.attendees[index] || {};
      const novoAttendee = {
        organizer: !!attendeeAtual.organizer
      };

      (items || []).forEach((item) => {
        if (!item || !item.key) return;
        novoAttendee[item.key] = item.value || "";
      });

      this.$set(this.attendees, index, novoAttendee);
      this.updateJson();
    },
    preencherForm(objJson) {
      objJson = JSON.parse(objJson.sendConfig.format);

      this.$emit("update:access", objJson.meeting.access);
      this.$emit("update:provider", objJson.meeting.provider);
      this.$emit("update:moderatorCode", objJson.meeting.moderator_code);
      this.$emit("update:password", objJson.meeting.password);
      this.$emit("update:sliToken", objJson.sli_token);

      this.summary = objJson.summary;
      this.calendarId = objJson.calendar_id;
      this.description = objJson.description;
      this.duration = objJson.duration;
      this.date_start = objJson.start_date_time;
      this.date_end = objJson.end_date_time;
      this.max_participants = objJson.meeting.max_participants;
      this.attendees = objJson.attendees;
      this.reminders = objJson.reminders;
      this.guestsCanInviteOthers = objJson.guestsCanInviteOthers;
      this.guestsCanModify = objJson.guestsCanModify;
      this.guestsCanSeeOtherGuests = objJson.guestsCanSeeOtherGuests;
      this.sendReminder = objJson.reminders.overrides.length > 0;
    }
  },
  created() {
    if (this.json["Teleconsulta"]) {
      const objJson = JSON.parse(this.json["Teleconsulta"]);
      this.preencherForm(objJson);
    }
  },
  props: {
    json: {
      required: true
    },
    sliToken: {
      required: true
    },
    access: {
      required: true
    },
    moderatorCode: {
      required: true
    },
    password: {
      required: true
    },
    provider: {
      required: true
    },
    availableVariables: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    sliToken() {
      this.loadCalendars(this.sliToken);
    },
    access() {
      this.updateJson();
    },
    moderatorCode() {
      this.updateJson();
    },
    password() {
      this.updateJson();
    }
  }
};
</script>

<style scoped>
.teleconsulta-options {
  margin: 0 auto;
}
.scroll-container {
  max-height: 300px;
  overflow-y: auto;
  padding-right: 15px; /* Evita que o conteúdo fique escondido pela barra de rolagem */
}
.btn-attendee {
  background-color: transparent;
  color: white;
}

.participant-card {
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  background-color: #f8fafc;
}
.participant-header {
  padding: 0.5rem 1rem;
  border-bottom: 1px solid #e2e8f0;
  background-color: #f1f5f9;
  border-radius: 0.5rem 0.5rem 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.participant-body {
  padding: 1rem;
  background-color: #ffffff;
  border-radius: 0 0 0.5rem 0.5rem;
}
.tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  align-items: center;
}
.custom-tag {
  display: inline-flex;
  align-items: stretch;
  border: 1px solid #cbd5e1;
  border-radius: 0.375rem;
  overflow: hidden;
  font-size: 0.875rem;
  background-color: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  position: relative;
}

.custom-tag.is-open {
  overflow: visible;
  z-index: 20;
}
.tag-label {
  padding: 0.35rem 0.5rem;
  background-color: #f1f5f9;
  color: #475569;
  font-weight: 500;
  border-right: 1px solid #cbd5e1;
  display: flex;
  align-items: center;
}
.tag-value {
  padding: 0.35rem 0.5rem;
  cursor: pointer;
  min-width: 90px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  font-style: italic;
  font-size: 0.75rem;
  transition: background-color 0.2s;
}
.tag-value.has-value {
  color: #472282; /* Cor principal do seu sistema */
  background-color: #f4f0fa;
  font-style: normal;
  font-weight: 600;
  font-family: monospace;
  font-size: 0.8rem;
}
.tag-value:hover {
  background-color: #f8fafc;
}
.tag-value.has-value:hover {
  background-color: #e9e3f5;
}
.tag-select {
  border: none !important;
  outline: none !important;
  background-color: transparent !important;
  color: #472282 !important;
  min-width: 240px;
  padding: 0.45rem 0.65rem !important;
  font-size: 0.8rem !important;
}

.tag-select-wrapper {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  display: inline-flex;
  flex-direction: column;
  align-items: stretch;
  background-color: #ffffff;
  min-width: 240px;
  border: 1px solid #cbd5e1;
  border-radius: 0.375rem;
  box-shadow: 0 12px 28px rgba(27, 39, 94, 0.15);
  z-index: 30;
}

.tag-options-list {
  max-height: 180px;
  overflow-y: auto;
  border-top: 1px solid #d9cfee;
  background-color: #fff;
}

.tag-option-item {
  width: 100%;
  text-align: left;
  border: none;
  background: transparent;
  color: #4c327a;
  padding: 0.45rem 0.65rem;
  font-size: 0.8rem;
  cursor: pointer;
}

.tag-option-item:hover {
  background-color: #f4f0fa;
}

.tag-option-item.active {
  background-color: #ede5fb;
  color: #472282;
}

.tag-option-empty {
  color: #7b6a9e;
  font-size: 0.75rem;
  padding: 0.45rem 0.65rem;
}
.tag-remove {
  padding: 0 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  border-left: 1px solid #cbd5e1;
  cursor: pointer;
}
.tag-remove:hover {
  color: #ef4444;
  background-color: #fef2f2;
}
.add-field-wrapper {
  display: inline-flex;
}
.btn-add-tag {
  background-color: #fff !important;
  color: #64748b !important;
  border: 1px dashed #cbd5e1 !important;
  font-size: 0.875rem !important;
  box-shadow: none !important;
}
.btn-add-tag:hover {
  border-color: #472282 !important;
  color: #472282 !important;
  background-color: #f4f0fa !important;
}
.input-add-tag {
  width: 140px !important;
  font-size: 0.875rem !important;
  height: auto !important;
  padding: 0.25rem 0.5rem !important;
}

.tag-key-input {
  border: none;
  outline: none;
  width: 120px;
  padding: 0.35rem 0.5rem;
  color: #472282;
  background-color: #f4f0fa;
  border-right: 1px solid #cbd5e1;
}

.btn-add-participant {
  background-color: #472282 !important;
  border-color: #472282 !important;
  color: #fff !important;
}
</style>
